import { NativeStackScreenProps } from '@react-navigation/native-stack';
import React from 'react';

import { MessagesModal } from '../Components';
import { RootStackParamList } from '../navigator';

type Props = NativeStackScreenProps<RootStackParamList, 'Messages'>;

const MessagesScreen: React.FC<Props> = ({ navigation, route }) => {
	return (
		<MessagesModal
			initialTab={route.params?.tab}
			onClose={() => {
				if (navigation.canGoBack()) {
					navigation.goBack();
				} else {
					navigation.navigate('Main');
				}
			}}
			onOpenFriendRequests={() => navigation.replace('Inventory', { tab: 'friends' })}
			onGoToSocial={() => navigation.replace('Friends')}
			// Replaces the Message Center rather than stacking on it: each modal draws its own scrim,
			// and two of them black out the screen behind.
			onOpenChat={conversation =>
				navigation.replace('PrivateChat', {
					playerId: conversation.otherPlayer.id,
					username: conversation.otherPlayer.username,
				})
			}
		/>
	);
};

export default MessagesScreen;
